import { render, staticRenderFns } from "./CtiDescription.vue?vue&type=template&id=9da3bdba&"
import script from "./CtiDescription.vue?vue&type=script&lang=js&"
export * from "./CtiDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports